(function (){
    const minimizerEl = document.getElementsByClassName('c-sidebar-minimizer')[0];
    const sidebarLogoEl = document.getElementById('sidebar');
    const cgmLogoEl = document.getElementById('cgmLogo');

    minimizerEl.addEventListener('click', function () {
        if(sidebarLogoEl.classList.contains('c-sidebar-minimized')) {
            cgmLogoEl.width = "30";
            cgmLogoEl.height = "30";
        }else {
            cgmLogoEl.width = "70";
            cgmLogoEl.height = "70"; 
        }
    })
}())